import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "../../../text";
import { Tooltip } from "../../../tooltip";
import { theme } from "../../../theme";
/**
 * @function CellRenderer
 * @description A component to render a demographic cell within a table.
 *              It renders a `Text` component with the cell's value and,
 *              if the cell doesn't match the one being added, renders a
 *              `Tooltip` with a message describing the mismatch.
 *
 * @param {Object} cell - The cell object with `value` and `label` properties.
 * @param {boolean} isMatching - Whether the cell matches the one being added.
 *
 */
export const CellRenderer = (cell, isMatching) => {
    const TextContent = () => {
        return (_jsx(Text, { as: "p", fontSize: 3, fontWeight: "medium", style: {
                backgroundColor: isMatching ? "" : `${theme.color.errorRed}20`,
                width: "fit-content",
            }, children: cell.value }));
    };
    if (isMatching) {
        return _jsx(TextContent, {});
    }
    return (_jsx(Tooltip, { content: `${cell.label} is different from the one you're adding.`, children: _jsx(TextContent, {}) }));
};
